import { useMediaQuery } from '@themenu/design-system'

export const useIsTouchDevice = (): boolean => {
  return useMediaQuery('(pointer: coarse)')
}
